import type { DEVICE_TYPE } from '@hotjar/global-filters';
import { isEqual } from 'lodash-es';
import type { DeviceFilterDto } from '../filters/FiltersMappings';
import { IncomingFeedbackDtoFilters } from '../filters/FiltersMappings';
import { DEFAULT_DEVICE_FILTER_VALUE } from '../filters/ResponsesFilters';

export function deviceFilterConverter(
  filterValue: DEVICE_TYPE[] | undefined,
): DeviceFilterDto | undefined {
  if (!filterValue || isEqual(filterValue, DEFAULT_DEVICE_FILTER_VALUE)) return undefined;
  return {
    type: IncomingFeedbackDtoFilters.DEVICE,
    values: filterValue,
  };
}
